import type { StatutConsigne } from './domaine'

// Revue des consignes (de tri et de fournisseur), dans Réglages : celles à activer (proposées par
// l'assistant) et celles à revoir (désactivées, ou actives sans avoir jamais servi un mois après
// leur activation : expéditeur, objet ou référence qui ne correspond peut-être à rien).

export const FILTRES_CONSIGNES = ['a_revoir', 'a_activer', 'toutes'] as const
export type FiltreConsignes = (typeof FILTRES_CONSIGNES)[number]

/** Délai après l'activation au-delà duquel une consigne qui n'a jamais servi est à revoir. */
export const JOURS_AVANT_REVUE = 30

export type ConsigneARevoir = {
  statut: StatutConsigne
  utilisations: number
  valideeLe: string | Date | null
  creeLe: string | Date
}

export function consigneARevoir(c: ConsigneARevoir, maintenant: Date): boolean {
  if (c.statut === 'inactive') return true
  if (c.statut !== 'active' || c.utilisations > 0) return false
  const depuis = new Date(c.valideeLe ?? c.creeLe).getTime()
  return maintenant.getTime() - depuis > JOURS_AVANT_REVUE * 86_400_000
}

export function consigneDansFiltre(
  filtre: FiltreConsignes,
  c: ConsigneARevoir,
  maintenant: Date,
): boolean {
  if (filtre === 'a_activer') return c.statut === 'proposee'
  if (filtre === 'a_revoir') return consigneARevoir(c, maintenant)
  return true
}

export function compterParFiltre(
  consignes: readonly ConsigneARevoir[],
  maintenant: Date,
): Record<FiltreConsignes, number> {
  const compte = { a_revoir: 0, a_activer: 0, toutes: 0 }
  for (const c of consignes)
    for (const f of FILTRES_CONSIGNES) if (consigneDansFiltre(f, c, maintenant)) compte[f]++
  return compte
}
